import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";
import { onGetSystemBalances, onPostSystemBalances } from "mocksdata/system-balances";
import { nanoid } from "nanoid";

/*Change Get Api here*/
const getApiSystemBalances = async (query) => {
  onGetSystemBalances();
  console.log(query);
  return axiosInstance({
    method: "get",
    url: "/merchants/service-fee",
    params: query,
  }).then((res) => {
    const currentData = res.data?.data?.map((item) => ({
      ...item,
      uniqueId: nanoid(10),
    }));

    return Promise.resolve({
      ...res.data,
      data: currentData,
    });
  });
};

/*Change Post Api here*/
const postApiSystemBalances = async (data) => {
  onPostSystemBalances(data);
  return await axiosInstance.post("/merchants/service-fee", data).then(handleResponse);
};

/*Change Put Api here*/
const putApiSystemBalances = async (id, data) => {
  return await axiosInstance.put("/merchants/service-fee", data).then(handleResponse);
};

/*Change Get Api here*/
const deleteApiSystemBalances = async (id, data) => {
  return await axiosInstance.delete("/merchants/service-fee", data).then(handleResponse);
};

export {
  getApiSystemBalances,
  postApiSystemBalances,
  putApiSystemBalances,
  deleteApiSystemBalances,
};
